/**
 * 右クリック禁止
 */
export class ClickControl {
  constructor() {
    this.init();
  }
  init() {
    document.oncontextmenu = function(){ return false; };
    document.body.oncontextmenu = "return false;"
  }
}
